<template>
    <div id="vehicle_manufacturer_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="vehicleManufacturerHeader" v-if="$route.params.id > 0">Update Asset Manufacturer</span>
                    <span class="page-title" id="vehicleManufacturerHeader" v-else>Add Asset Manufacturer</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackVehicleManufacturerList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content ">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="VehicleManufacturerForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Name:</label>
                                        <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Name" name="name">
                                        <div class="field-error">{{name_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                    <label class="control-label require" for="code">Code:</label>
                                        <input type="text" class="form-control" v-model="code" id="code" placeholder="Enter Code" name="code">
                                        <div class="field-error">{{code_error_msg}}</div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createVehicleManufacturerBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateVehicleManufacturer" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="createVehicleManufacturerBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateVehicleManufacturer" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueVehicleManufacturerBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateVehicleManufacturer(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelVehicleManufacturerBtn" class="btn btn-tertiary" v-on:click.prevent="BackVehicleManufacturerList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>    
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';
export default {
  name: "VehicleManufacturerCreate",
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Asset Manufacturer | " +process.env.COPYRIGHT_NAME : "Create Asset Manufacturer | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    name: "",
    code: "",
    loading:false,
    name_error_msg: "",
    code_error_msg: ""
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_asset_manufacturer') {
                        self.cantAccessPage = true;

                    }
                }
            }

        }

  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        var path = window.location.pathname;
        var segments = path.split("/");
        
        if (segments[3]) {
            self.loadVehicleManufacturer();
        }
  },
  methods: {

    BackVehicleManufacturerList() {
      var self = this;
      self.$router.push("/assetmanufacturer/list");
    },

    CreateVehicleManufacturer(flag) {
        var self = this;

        self.code = self.code.trim();
        self.name = self.name.trim();

        self.name_error_msg = "";
        self.code_error_msg = "";

        if (!self.name || self.name == null || self.name == "") {
            self.name_error_msg = "Name Required.";
        }

        if (!self.code || self.code == null || self.code == "") {
            self.code_error_msg = "Code Required.";
        }

        if (self.name_error_msg == "" && self.code_error_msg == "") {

            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createVehicleManufacturerBtn").val("Updating ...");
                $("#createVehicleManufacturerBtn").prop("disabled", true);
                $("#cancelVehicleManufacturerBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueVehicleManufacturerBtn").val("Saving ...");
                    $("#createVehicleManufacturerBtn").prop("disabled", true);
                    $("#createAndContinueVehicleManufacturerBtn").prop("disabled", true);
                    $("#cancelVehicleManufacturerBtn").prop("disabled",true);

                }else{

                    $("#createVehicleManufacturerBtn").val("Saving ...");
                    $("#createVehicleManufacturerBtn").prop("disabled", true);
                    $("#createAndContinueVehicleManufacturerBtn").prop("disabled", true);
                    $("#cancelVehicleManufacturerBtn").prop("disabled",true);
                }
               
            }
            
            $.ajax({
                url: process.env.ROOT_API + "/assetmanufacturer/create",
                type: "POST",
                data: {name: self.name,id: segments[3], code: self.code},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createVehicleManufacturerBtn").val("Update");
                        $("#createVehicleManufacturerBtn").prop("disabled", false);
                        $("#cancelVehicleManufacturerBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueVehicleManufacturerBtn").val("Save and Continue");
                            $("#createVehicleManufacturerBtn").prop("disabled", false);
                            $("#createAndContinueVehicleManufacturerBtn").prop("disabled", false);
                            $("#cancelVehicleManufacturerBtn").prop("disabled",false);

                        }else{

                            $("#createVehicleManufacturerBtn").val("Save");
                            $("#createVehicleManufacturerBtn").prop("disabled", false);
                            $("#createAndContinueVehicleManufacturerBtn").prop("disabled", false);
                            $("#cancelVehicleManufacturerBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            // $("#VehicleStatusForm").trigger("reset");
                            self.name = "";
                            self.code = "";

                        }else{
                            self.$router.push("/assetmanufacturer/list");
                        }
                        
                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createVehicleManufacturerBtn").val("Update");
                        $("#createVehicleManufacturerBtn").prop("disabled", false);
                        $("#cancelVehicleManufacturerBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            // $("#VehicleStatusForm").trigger("reset");
                            
                            $("#createAndContinueVehicleManufacturerBtn").val("Save and Continue");
                            $("#createVehicleManufacturerBtn").prop("disabled", false);
                            $("#createAndContinueVehicleManufacturerBtn").prop("disabled", false);
                            $("#cancelVehicleManufacturerBtn").prop("disabled",false);

                        }else{

                            $("#createVehicleManufacturerBtn").val("Save");
                            $("#createVehicleManufacturerBtn").prop("disabled", false);
                            $("#createAndContinueVehicleManufacturerBtn").prop("disabled", false);
                            $("#cancelVehicleManufacturerBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'asset-manufacturer-create')
                }
            });
        }else{
          self.errorValidationFocus();
      }
    },

    loadVehicleManufacturer() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/assetmanufacturer/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    self.name = data.content.name;
                    self.code = data.content.code;
                } 
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'asset-manufacturer-get-by-id')
            }
        });
    },
  }
};
</script>   


// WEBPACK FOOTER //
// src/components/AssetManufacturerCreate.vue